import { Backdrop, Box, CircularProgress } from "@mui/material";
import { TreeSelect } from "primereact/treeselect";
import { React, useState, useEffect } from "react";
import api from "utils/api";
import useAuth from "hooks/useAuth";

import "primereact/resources/themes/lara-light-indigo/theme.css"; //theme
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "./tree.css";

import { useEmployeeDirectoryState } from "contexts/employeeDirectoryContext";
//go through tree search for a specific node id
function searchTree(node, node_id) {
  if (node.key == node_id) {
    return node;
  } else if (node.children != null) {
    var i;
    var result = null;
    for (i = 0; result == null && i < node.children.length; i++) {
      result = searchTree(node.children[i], node_id);
    }
    return result;
  }
  return null;
}

const Tree = () => {
  const [groups, setGroups] = useState(null);
  const [selectedNodeKey, setSelectedNodeKey] = useState(null);
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [fetchedGroups, setFetchedGroups] = useState([]);
  const [expandedKeys, setExpandedKeys] = useState({});
  const [loading, setLoading] = useState(false);

  const { setGroups: setStateGroups } = useEmployeeDirectoryState();

  const { user } = useAuth();

  useEffect(async () => {
    let result = await api.getCompanyGroups(user.rootGroupId);
    let root_groups = result.data.map((child) => ({
      key: child.id,
      label: child.name + " (" + child.code + ")",
      data: child.name + " (" + child.code + ")",
      leaf: false,
    }));
    setGroups(root_groups);
  }, []);

  const onNodeSelect = async (e) => {
    const test = [...selectedGroups, e.node.key];
    setSelectedGroups(test);
    let groups = {};
    for (let group of test)
      groups[group] = { checked: true, partialChecked: false };
    setSelectedNodeKey(groups);
    // let g = selectedGroups;
    // g.push(e.node.key);
    // setSelectedGroups(g);
    setLoading(true);
    setStateGroups(test.join(","));
    setLoading(false);
  };

  const onNodeUnselect = async (e) => {
    // let g = selectedGroups;
    // g.splice(g.indexOf(e.node.key), 1);
    // setSelectedGroups(g);
    const test = selectedGroups.filter((group) => group !== e.node.key);
    setSelectedGroups(test);
    let groups = {};
    for (let group of test)
      groups[group] = { checked: true, partialChecked: false };
    setSelectedNodeKey(groups);
    setLoading(true);
    setStateGroups(test.join(","));
    // let result = await api.getEmployeeDirectory(50, 0, selectedGroups.join(","));
    setLoading(false);
  };

  const onNodeExpand = async (e) => {
    //if already fetched this group from db, skip...
    if (fetchedGroups.indexOf(e.node.key) > -1) return;

    setLoading(true);
    let result = await api.getCompanyGroups(e.node.key);
    setLoading(false);
    let children = result.data.map((child) => ({
      key: child.id,
      label: child.name + " (" + child.code + ")",
      leaf: false,
    }));

    let g = groups;
    g.forEach((group) => {
      let target = searchTree(group, e.node.key);
      if (target) {
        target.children = children;
      }
    });

    setGroups(g);
    let fg = fetchedGroups;
    fg.push(e.node.key);
    setFetchedGroups(fg);

    if (Object.keys(expandedKeys).length === 0) {
      setExpandedKeys(e.node.key);
    } else {
      let newExpandedKeys = { ...expandedKeys };
      if (newExpandedKeys[e.node.value]) delete newExpandedKeys[e.node.value];
      else newExpandedKeys[e.node.value] = true;

      setExpandedKeys(newExpandedKeys);
    }
  };

  return (
    <Box>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <TreeSelect
        display="chip"
        selectionMode="checkbox"
        value={selectedNodeKey}
        options={groups}
        onChange={(e) => {
          e.preventDefault();
        }}
        placeholder="Choisir entitées..."
        onNodeExpand={onNodeExpand}
        onNodeSelect={onNodeSelect}
        onNodeUnselect={onNodeUnselect}
        expandedKeys={expandedKeys}
        filter={true}
        panelClassName="Hello"
        style={{
          zIndex: 9999,
          minWidth: "280px",
          maxWidth: "700px",
          border: "none",
        }}
        appendTo="self"
      />
    </Box>
  );
};

export default Tree;
